export interface AccountApprovalClass {
    AccountApprovalTypeId: number
    ApprovalTypeName: string
    AccountId: number
    MasterAccountApprovalTypeId:number
    IsTimeOffApprovalTypes:boolean
    IsDeleted:boolean
    isSelected:number
    detail:Array<AccountApprovalPathsClass>
}

export interface AccountApprovalPathsClass {
  AccountApprovalPathId:number
  AccountApprovalTypeId: number
  AccountEmployeeId: number
  AccountExternalUserId: number
  AccountId:number
  ApprovalPathSequence:number
  MasterAccountApprovalPathId:number
  SystemApproverTypeId:number
  isSelected:number
}

// const common = {    
//     ApprovalTypeName: "",
//     MasterAccountApprovalTypeId:0,
//     IsTimeOffApprovalTypes:false,
//     IsDeleted:false,
//     detail:[]
//   };
  //...common 
  export const accountApprovalInitialsForAdd = { 
    
   ApprovalTypeName: "",
    MasterAccountApprovalTypeId:0,
    IsTimeOffApprovalTypes:false,
    IsDeleted:false,
    detail:[]
  };
  
  export const accountApprovalInitialsForUpdate = {
   
    AccountApprovalTypeId: 0,
    ApprovalTypeName: "",
    MasterAccountApprovalTypeId:0,
    IsTimeOffApprovalTypes:false,
    IsDeleted:false,
    detail:[]
  };
  